// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  archetypeId: __t.string().primaryKey().name("archetype_id"),
  weight: __t.u32(),
  patienceMultX100: __t.i32().name("patience_mult_x100"),
  tipMultX100: __t.i32().name("tip_mult_x100"),
  orderSizeBias: __t.i32().name("order_size_bias"),
  wcUseChanceX100: __t.i32().name("wc_use_chance_x100"),
});
